import { Route } from "react-router-dom";
import ClientAppointmentSuccess from "../components/appointment-success";

const ClientAppointmentSuccessRoutes = () => (
  <>
    <Route path="/client-appointment-success" element={<ClientAppointmentSuccess />} />
  </>
);


export default ClientAppointmentSuccessRoutes;